// src/pages/Videos.jsx
import React from "react";
import VideoPlayer from "../components/VideoPlayer";
import { videos } from "../data/videos";
import styles from "./VideoGrid.module.css";

function Videos() {
  return (
    <div className={styles.videoPage}>
      <h1 className={styles.pageTitle}>Family Videos</h1>
      <p className={styles.pageSubtitle}>
        (More videos coming soon!)
        {/* Relive some of our favorite family moments.  */}
      </p>

      {/* The grid container for all the videos */}
      <div className={styles.videoGrid}>
        {videos.map((video) => (
          <div key={video.id} className={styles.videoCard}>
            {/* The VideoPlayer component will be rendered for each video item */}
            <VideoPlayer youtubeId={video.youtubeId} />
            <h2 className={styles.videoTitle}>{video.title}</h2>
            {video.caption && (
              <p className={styles.videoCaption}>{video.caption}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Videos;
